import { push } from 'connected-react-router';
import { CAMPAIGNS_DASHBOARD_PAGE_ROUTE } from 'utils/constants/app';
import { PAGE_SIZE } from 'utils/constants/campaign';

import { fetchCampaignsCounts } from 'components/CampaignsDashboard/utils/fetchCampaignsCounts';

import {
    CampaignsCounts,
    DashboardCampaign,
    setCampaigns,
    setIsCampaignsLoading,
} from 'store/models/campaignsDashboard';
import { AppThunkAction } from 'store/utils';

export const setCampaignsOrRefetchEmptyPage =
    (newCampaignsList: Map<number, DashboardCampaign>, abortSignal: AbortSignal): AppThunkAction<void> =>
    (dispatch, getState) => {
        dispatch(setCampaigns(newCampaignsList));

        const { campaignsCurrentPage, campaignsCurrentTab } = getState().campaignsDashboard;

        const navigateToValidPage = (campaignsCounts: CampaignsCounts) => {
            const totalPages = Math.ceil(campaignsCounts[campaignsCurrentTab] / PAGE_SIZE);
            const pushPage = Math.min(campaignsCurrentPage, Math.max(totalPages, 1));

            if (pushPage !== campaignsCurrentPage) {
                dispatch(setIsCampaignsLoading(true));
                dispatch(push(`${CAMPAIGNS_DASHBOARD_PAGE_ROUTE}${campaignsCurrentTab}?page=${pushPage}`));
            }
        };

        void dispatch(fetchCampaignsCounts(abortSignal)).then(navigateToValidPage, () => {
            if (abortSignal.aborted) {
                return;
            }
            navigateToValidPage(getState().campaignsDashboard.campaignsCounts);
        });
    };
